const {
    REACT_APP_BASE_URL
} = process.env;

export const BASE_API = REACT_APP_BASE_URL;